import { useBreakpoint } from '@contexts/breakpoints';

import DesktopHeaderReservations from './DesktopHeaderReservations';
import MobileTransactions from './MobileTransactions';

const HeaderReservations = () => {
  const { xl } = useBreakpoint();

  if (xl || xl === undefined) {
    return <DesktopHeaderReservations />;
  }

  return <MobileTransactions />;
};

export default HeaderReservations;
